import {
  GET_MASTER_PAYMENT_PROVIDER_LIST,
  GET_MASTER_PAYMENT_PROVIDER_LIST_SUCCESS,
  GET_MASTER_PAYMENT_PROVIDER_LIST_FAIL,
  GET_MASTER_PAYMENT_PROVIDER_DATA,
  GET_MASTER_PAYMENT_PROVIDER_DATA_SUCCESS,
  GET_MASTER_PAYMENT_PROVIDER_DATA_FAIL,
  CREATE_MASTER_PAYMENT_PROVIDER,
  CREATE_MASTER_PAYMENT_PROVIDER_SUCCESS,
  CREATE_MASTER_PAYMENT_PROVIDER_FAIL,
  UPDATE_MASTER_PAYMENT_PROVIDER,
  UPDATE_MASTER_PAYMENT_PROVIDER_SUCCESS,
  UPDATE_MASTER_PAYMENT_PROVIDER_FAIL,
  DELETE_MASTER_PAYMENT_PROVIDER,
  DELETE_MASTER_PAYMENT_PROVIDER_SUCCESS,
  DELETE_MASTER_PAYMENT_PROVIDER_FAIL,
} from "./actionType";

// Actions

// Get all masterPaymentProviders
export const getMasterPaymentProviderList = () => ({
  type: GET_MASTER_PAYMENT_PROVIDER_LIST,
});

export const getMasterPaymentProviderListSuccess = (data) => ({
  type: GET_MASTER_PAYMENT_PROVIDER_LIST_SUCCESS,
  payload: data,
});

export const getMasterPaymentProviderListFail = (error) => ({
  type: GET_MASTER_PAYMENT_PROVIDER_LIST_FAIL,
  payload: error,
});

// Get single masterPaymentProvider
export const getMasterPaymentProviderData = (id) => ({
  type: GET_MASTER_PAYMENT_PROVIDER_DATA,
  payload: id,
});

export const getMasterPaymentProviderDataSuccess = (data) => ({
  type: GET_MASTER_PAYMENT_PROVIDER_DATA_SUCCESS,
  payload: data,
});

export const getMasterPaymentProviderDataFail = (error) => ({
  type: GET_MASTER_PAYMENT_PROVIDER_DATA_FAIL,
  payload: error,
});

// Create masterPaymentProvider
export const createMasterPaymentProvider = (data) => ({
  type: CREATE_MASTER_PAYMENT_PROVIDER,
  payload: data,
});

export const createMasterPaymentProviderSuccess = (data) => ({
  type: CREATE_MASTER_PAYMENT_PROVIDER_SUCCESS,
  payload: data,
});

export const createMasterPaymentProviderFail = (error) => ({
  type: CREATE_MASTER_PAYMENT_PROVIDER_FAIL,
  payload: error,
});

// Update masterPaymentProvider
export const updateMasterPaymentProvider = (data) => ({
  type: UPDATE_MASTER_PAYMENT_PROVIDER,
  payload: data,
});

export const updateMasterPaymentProviderSuccess = (data) => ({
  type: UPDATE_MASTER_PAYMENT_PROVIDER_SUCCESS,
  payload: data,
});

export const updateMasterPaymentProviderFail = (error) => ({
  type: UPDATE_MASTER_PAYMENT_PROVIDER_FAIL,
  payload: error,
});

// Delete masterPaymentProvider
export const deleteMasterPaymentProvider = (id) => ({
  type: DELETE_MASTER_PAYMENT_PROVIDER,
  payload: id,
});

export const deleteMasterPaymentProviderSuccess = (data) => ({
  type: DELETE_MASTER_PAYMENT_PROVIDER_SUCCESS,
  payload: data,
});

export const deleteMasterPaymentProviderFail = (error) => ({
  type: DELETE_MASTER_PAYMENT_PROVIDER_FAIL,
  payload: error,
});
